import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import calander from 'assets/images/calendar-blue.svg';
import clock from 'assets/images/clock-blue.svg';
import { useDispatch } from 'react-redux';
import { transcationActions } from '../../../stores/_actions';

export const Transcations = (props) => {
  let items = props.list;
  let styles = props.styles;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(transcationActions.setLastVisitedPage('My Transfers'));
  }, []);

  return (
    items &&
    items.map((item, index) => {
      return (
        <div className={styles.beneficiary__Bitem} key={index}>
          <h3>
            {' '}
            <span>{item.BenfName}</span>
            <span>
              {item?.CurrencyCode} {item?.FCYAmt}
            </span>{' '}
          </h3>
          <p>
            <span className={styles.mytransferLeft}>
              <span>
                <img src={calander} alt="" />
                {item?.Trandate.toString().split(' ')[0]}
              </span>
              <span>
                <img src={clock} alt="" />
                {item.Trandate.toString().split(' ')[1]}
              </span>
            </span>
            <span>@{item?.MRate}</span>
          </p>
          <h4>
            {item?.Refno}
            <span>{item?.Status}</span>
          </h4>
          <h6>
            <span className={styles.viewdetails}>
              <Link to={{ pathname: '/transcation-view', state: { refno: item.Refno } }}>View Details </Link>
            </span>
          </h6>
        </div>
      );
    })
  );
};
